<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <div class="icon-set">
        <div
          class="icon-set-content"
          v-for="(item, index) in items"
          :key="`${index}-${item.label}`"
          :title="item.label"
        >
          <CustomIcon
            v-if="item.icon"
            :name="item.icon"
            :className="item.value"
          />
          <p v-if="item.label" class="icon-set-content-text">
            {{ item.label }}
          </p>
        </div>
      </div>
      <CustomButton variation="primary" :onClick="action"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";

export default {
  components: {
    CustomIcon,
    CustomButton,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    items: {
      type: Array,
      default: () => [
        {
          id: String,
          label: String,
          to: String,
          icon: String,
          text: String,
          description: String,
          isActive: Boolean,
          target_field: String,
          value: [String, Boolean, Array],
        },
      ],
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
